import { InHomeBookingResult } from '@Medology/ng-findalab';

import { OrderSummary } from './order-summary';
import { ReviewsFeature } from './reviews-feature';

export class OrderCompleteDetails {
  public summary: OrderSummary;
  public transactionId: string;
  public free: boolean;
  public reviewsFeature: ReviewsFeature;
  public sendSms: boolean;
  public hasEmail: boolean;
  public isPayLater: boolean;
  public hash: string;
  public inHomeBookingResult?: InHomeBookingResult;
  public email?: string;

  public constructor(
    summary: OrderSummary,
    transactionId: string,
    free: boolean,
    reviewsFeature: ReviewsFeature,
    sendSms: boolean,
    hasEmail: boolean,
    isPayLater: boolean,
    hash: string,
    inHomeBookingResult?: InHomeBookingResult,
    email?: string,
  ) {
    this.summary = summary;
    this.transactionId = transactionId;
    this.free = free;
    this.reviewsFeature = reviewsFeature;
    this.sendSms = sendSms;
    this.hasEmail = hasEmail;
    this.isPayLater = isPayLater;
    this.hash = hash;
    this.inHomeBookingResult = inHomeBookingResult;
    this.email = email;
  }
}
